<template>
    <div class="def-select-wrapper">
        <input type="hidden" :name="size.name" :value="size.value">
        <div class="def-select-wrapper__front"
             :class="{ 'def-select-wrapper__front_center': !$slots.placeholder }"
             @click="active = !active"
        >
            <span v-if="$slots.placeholder" class="def-select-wrapper__placeholder"
                  :class="{ 'def-select-wrapper__center': $slots.header && !$slots.header[0].text.trim().length }">
                <slot  name="placeholder" />
            </span>
            <span><slot v-if="$slots.header" name="header" /></span>
            <svg :class="{ 'def-select-wrapper__close_active': active }" class="def-select-wrapper__close">
                <use xlink:href="#svg-arrow-select"></use>
            </svg>
        </div>
        <SlideUpDown :modelValue="active" class="def-select-wrapper__drop">
            <PerfectScrollbar class="def-select-wrapper__scroll">
                <div class="def-select-wrapper__items" @click="active = false">
                    <slot />
                </div>
            </PerfectScrollbar>
        </SlideUpDown>
    </div>
</template>

<script>
export default {
    name: "def-select-wrapper",
    props: {
        size:{
            type: [Array, Object],
        }
    },
    data: () => ({
        active: false,
    }),
    watch: {
        active(prevState) {
            if (prevState) {
                document.addEventListener('click', this.closeSelect);
            } else {
                document.removeEventListener('click', this.closeSelect);
            }
        }
    },
    methods: {
        closeSelect({ target }) {
            if (target.closest('.def-select-wrapper') !== this.$el) {
                this.active = false;
            }
        }
    }
}
</script>

<style scoped lang="scss">
.def-select-wrapper{
    width: 100%;
    position: relative;
    font-size: rem(14);
    @include point-md{
        font-size: rem(16);
    }
    &__front{
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        cursor: pointer;
        background: #FFFFFF;
        border-radius: 4px;
        padding: 6px 32px 6px 18px;
        min-height: 48px;
        border: 1px solid #E5E5E5;
        position: relative;
        height: 100%;
        &_center{
            justify-content: center;
        }
    }
    &__placeholder{
        font-size: rem(12);
        line-height: 135%;
        color: #85898B;
        margin-bottom: 2px;
        position: absolute;
        top: 6px;
        transition: .2s linear top, .2s linear font-size;
        white-space: nowrap;
        overflow: hidden;
        display: block;
        max-width: calc(100% - 42px);
        text-overflow: ellipsis;
    }
    &__center{
        top: 50%;
        transform: translateY(-50%);
        font-size: rem(16);
    }
    &__drop{
        position: absolute;
        left: 0;
        right: 0;
        top: calc(100% + 4px);
        background-color: #fff;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
        border-radius: 4px;
        z-index: 2;
    }
    &__scroll{
        max-height: 250px;
        overflow-y: auto;
    }
    &__items{
        & > * {
            padding: 8px 18px;
            cursor: pointer;
            &:hover{
                background-color: #FAFAFA;
            }
        }
    }
    &__close{
        position: absolute;
        transition: .2s linear transform;
        top: 50%;
        transform: translateY(-50%);
        right: 14px;
        width: 24px;
        height: 24px;
        &_active{
            transform: translateY(-50%) rotate(180deg);
        }
    }
}
</style>